import type { FC, PropsWithChildren } from 'react';

import { TextButton } from '@xing-com/button';
import { IconArrowLeft } from '@xing-com/icons';

import { StyledSubHeaderWrapper } from './zen-view-sub-header.styles';

type ZenViewSubHeaderProps = {
  backLink: {
    label: string;
    onClose: () => void;
  };
};

export const ZenViewSubHeader: FC<PropsWithChildren<ZenViewSubHeaderProps>> = ({
  backLink: { label, onClose },
}) => {
  return (
    <StyledSubHeaderWrapper>
      <TextButton size="small" onClick={onClose} icon={IconArrowLeft}>
        {label}
      </TextButton>
    </StyledSubHeaderWrapper>
  );
};
